<template>
  <div>
    <div class="header">
      <el-select class="form-input" size="mini" filterable v-model="flow_professional_work_id" :filter-method="getFlowProfessionalWorkList" placeholder="请选择动作">
        <el-option
          v-for="item in flow_professional_work_list"
          :key="item.id"
          :label="item.name"
          :value="item.id">
        </el-option>
      </el-select>
      <el-button size="mini" type="primary" icon="el-icon-circle-plus" circle @click="addTableData"></el-button>
    </div>
    <el-table
      :data="tableData"
      size="mini"
      style="width: 100%">
      <el-table-column
        prop="id"
        width="50"
        label="ID"></el-table-column>
      <el-table-column
        prop="name"
        label="触发类型" width="100">
        <template slot-scope="scope">
          <el-select class="form-input" size="mini" filterable v-model="scope.row.type" @change="changeInput(scope.$index,scope.row)" placeholder="触发类型">
            <el-option
              v-for="(item,index) in flow_monitor_type_list"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="名称"></el-table-column>
      <el-table-column label="操作" width="50">
        <template slot-scope="scope">
          <el-button type="danger" size="mini" icon="el-icon-delete" @click="delTableData(scope.$index)" circle></el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import Http from "../../../common/Http";

export default {
  name: "BpmnMonitor",
  props:{
    tableDataProps:{
      type:Array,
      default(){
        return [];
      }
    }
  },
  model:{
    prop:"tableDataProps",
    event:"success",
  },
  data() {
    return {
      flow_monitor_type_list:[
        {name:"同意",value:"Y"},
        {name:"拒绝",value:"N"},
      ],
      tableData:[],
      flow_professional_work_list:[],
      flow_professional_work_id:""
    }
  },
  mounted() {
    this.onInitTable()
    this.getFlowProfessionalWorkList()
  },
  watch: {
    tableDataProps:{
      deep:true,
      immediate:true,
      handler(n){
        this.onInitTable()
      }
    }
  },
  computed: {},
  methods: {
    onInitTable(){
      this.tableData=this.tableDataProps
    },
    addTableData(){
      const that=this;
      let index=that.flow_professional_work_list.findIndex(ret=>ret.id===that.flow_professional_work_id)
      if(index!==-1){
        let p_index=that.tableData.findIndex(ret=>ret.id===that.flow_professional_work_id)
        if(p_index!==-1){
          that.$message.error("已经选择")
          return false;
        }
        let obj={
          ...that.flow_professional_work_list[index],
          type:"Y"
        }
        that.tableData.push(JSON.parse(JSON.stringify(obj)));
        that.$emit("success",that.tableData)
      }else {
        that.$message.error("请选择业务")
      }
    },
    delTableData(index){
      this.tableData.splice(index,1);
      this.$emit("success",this.tableData)
    },
    changeInput(index,item){
      this.tableData[index]=item;
      this.$emit("success",this.tableData)
    },
    changeInput2(id,name,val){
      const that=this;
      that.tableData[id][name]=val;
      that.$emit("success",that.tableData)
    },
    getFlowProfessionalWorkList(name="") {
      const that = this;
      let where={status:1};
      name&&(where.name=name);
      Http.get("flow/FlowProfessionalWork/getList",{
        where:JSON.stringify(where),
        page: 1,
        page_size: 100
      },res=>{
        if(res.code) {
          that.flow_professional_work_list=res.data.list
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../../common";
.header{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.form-input{
  width: 100%;
}
.footer{
  margin: 5px 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/bpmn/PropertySetting/components/BpmnMonitor.vue